import React, { useCallback } from 'react';

import { Typography } from '@mui/material';
import clsx from 'clsx';
import { ToggleSwitch } from 'src/components/generic';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  toggleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

interface ToggleProps {
  text: string;
  toggle: (value: boolean) => void;
  value: boolean;
  className?: string;
  dataCy?: string;
  disabled?: boolean;
}

export function ToggleRow({
  className,
  dataCy,
  disabled,
  text,
  toggle,
  value,
}: ToggleProps): JSX.Element {
  const { classes } = useStyles();
  const flip = useCallback(() => toggle(!value), [toggle, value]);
  const flipWithKey = useCallback(
    (event: React.KeyboardEvent) => {
      if (disabled || (event.key !== ' ' && event.key !== 'Enter')) return;
      event.preventDefault();
      flip();
    },
    [disabled, flip]
  );

  return (
    <div className={clsx(className, classes.toggleContainer)}>
      <Typography variant="body1">{text}</Typography>
      <ToggleSwitch
        aria-checked={value}
        aria-disabled={Boolean(disabled)}
        aria-label={text}
        dataCy={dataCy}
        disabled={disabled}
        role="switch"
        tabIndex={disabled ? -1 : 0}
        toggle={flip}
        toggled={value}
        onKeyDown={flipWithKey}
      />
    </div>
  );
}
